import React, { Suspense, lazy } from 'react';

// Keep Hero component loaded immediately for FCP/LCP
import HeroOptimized from './Hero Section/HeroOptimized';
import { Helmet } from 'react-helmet';

// Lazy load non-critical components
const NewArrivals = lazy(() => import('./New Arrivals/NewArrivals'));
const FeaturedBooks = lazy(() => import('./Featured Books/FeaturedBooks'));
const MostPopular = lazy(() => import('./Most Popular/MostPopular'));
const CategoriesSwapper = lazy(() => import('./Categories Swapper/CategoriesSwapper'));
const Quote = lazy(() => import('./Quote Section/Quote'));
const SubCategorySwiper = lazy(() => import('./SubCategory Swiper/SubCategorySwiper'));
const TopTrending = lazy(() => import('./Top Trend/TopTrending'));
const SocialMedia = lazy(() => import('./Social Media/SocialMedia'));

const LoadingFallback = ({ height = '200px' }) => (
  <div style={{ 
    height, 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    color: '#666'
  }}>
    Loading...
  </div>
);

const Home = () => {
  return (
    <div>
      <Helmet>
        <h1>{process.env.REACT_APP_TITLE}</h1>
        <title>{process.env.REACT_APP_TITLE}</title>
        <meta name="description" content={process.env.REACT_APP_DESCRIPTION} />
        {/* <link rel="canonical" href={process.env.REACT_APP_CANONICAL_URL} /> */}
      </Helmet>
      {/* Critical above-the-fold content - LCP optimized */}
      <HeroOptimized />

      <Suspense fallback={<LoadingFallback height="300px" />}>
        <SubCategorySwiper />
      </Suspense>
      
      {/* Lazy load below-the-fold components */}
      <Suspense fallback={<LoadingFallback height="300px" />}>
        <NewArrivals />
      </Suspense>
      
      <Suspense fallback={<LoadingFallback height="400px" />}>
        <FeaturedBooks />
      </Suspense>

      <Suspense fallback={<LoadingFallback height="400px" />}>
        <TopTrending />
      </Suspense>

      <Suspense fallback={<LoadingFallback height="400px" />}>
        <SocialMedia />
      </Suspense>
      
      <Suspense fallback={<LoadingFallback height="350px" />}>
        <MostPopular />
      </Suspense>
      
      <Suspense fallback={<LoadingFallback height="250px" />}>
        <Quote />
      </Suspense>
      
      <Suspense fallback={<LoadingFallback height="200px" />}>
        <CategoriesSwapper />
      </Suspense>
    </div>
  );
};

export default Home;
